export default __webpack_public_path__ + "c8464263311c68d811f15d1b1cda4ca5.png";